import React, { Component } from "react";
import { View, ScrollView, TouchableOpacity, SafeAreaView } from 'react-native';
import { connect } from "react-redux";
import { openLink } from "../../../functions";
import styles from "../../../styles";
import Header from "../../../components/Header";
import { changeUserProfile, passwordValidate, logoutUser } from "../../../action";
import { global, action } from "../../../const";
import { PrimaryTitle, LinkIndigo } from "../../../components/labels";
import PasswordInput from "../../../components/form/PasswordInput";
import Button from "../../../components/form/Button";
import SuccessDialog from "../../../components/modal/SuccessDialog";
import localize from "../../../localize";

class ResetUserPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPassword: "",
            currentPassowrdError: null,
            isValiad: false,
            newPassword: "",
            passwordError: localize.Must_be_a_minimum,
            isVisible: false,
            status: false,
            progress: 0
        }
    }

    onCurrentPasswordChange = async (currentPassword) => {
        this.setState({ currentPassword, isValiad: false })
        if (currentPassword.length < 4) return;
        let res = await this.props.changeUserProfile({ cmd: "WcnUser1.verifyCurrentPassword", old_password: currentPassword })
        if (res === 200) return this.setState({ currentPassowrdError: null, isValiad: true })
        return this.setState({ currentPassowrdError: localize.Verify_your_current, isValiad: false })
    }

    onPasswordChange = async (password) => {
        this.setState({ newPassword: password, passwordError: this.state.passwordError, status: true });
        let response = await this.props.passwordValidate(password);
        this.setState({ passwordError: response.message, progress: response.progress });
    }

    onResetPassword = async () => {
        const { newPassword, currentPassword, isValiad } = this.state;
        if (!isValiad) return;
        this.props.isLoading(true);
        let res = await this.props.changeUserProfile({ new_password: newPassword, old_password: currentPassword, cmd: "WcnUser1.changePassword" })
        this.props.isLoading(false);
        return this.resetPasswordStatus(res)
    }

    logout = () => {
        this.props.logoutUser();
        this.props.history.push("/SignIn");
    }

    render() {
        const { newPassword, currentPassowrdError, currentPassword, progress, isVisible, passwordError } = this.state;
        return (
            <SafeAreaView styles={styles.container}>
                <Header title={localize.Password_Reset} goBack={() => this.props.history.goBack()} />
                <ScrollView keyboardShouldPersistTaps="handled" bounces={false}>
                    <View style={{ paddingHorizontal: 20, paddingVertical: 15 }}>
                        <PrimaryTitle size={15}>
                        {localize.to_set_new_password}
                        </PrimaryTitle>
                        <View style={{ height: 40 }} />
                        <PasswordInput
                            title={localize.current_password}
                            placeholder={localize.enter_password}
                            value={currentPassword}
                            onChangeText={this.onCurrentPasswordChange}
                            error={currentPassowrdError}
                            progressVisible={false}
                        />
                        <View style={{ height: 10 }} />
                        <PasswordInput
                            title={localize.New_password}
                            placeholder={localize.New_password}
                            value={newPassword}
                            onChangeText={this.onPasswordChange}
                            progressVisible={true}
                            progressVisible
                            progress={progress}
                            error={passwordError}
                        />
                    </View>
                    <View style={{ margin: 20 }}>
                        <Button
                            title={localize.change}
                            disabled={this.handleButtonDisable()}
                            onPress={this.onResetPassword}
                            size="small"
                        />
                        <View style={{ height: 10 }} />
                        <Button
                            title={localize.cancel}
                            size="small"
                            onPress={() => global.isNative ? this.props.navigation.goBack() : this.props.history.goBack()}
                            variant="outline"
                        />
                    </View>
                    <TouchableOpacity
                        onPress={() => openLink(global.FORGOTPASSWORD_URL)}
                        style={{ alignSelf: "center", marginVertical: 10, marginHorizontal: 20 }}
                    >
                        <LinkIndigo>
                        {localize.forgot_password}
                        </LinkIndigo>
                    </TouchableOpacity>
                </ScrollView>
                <SuccessDialog
                    isVisible={isVisible}
                    onCancel={this.logout}
                    buttonTitle={localize.Ok}
                    buttonAction={this.logout}
                    title={localize.Password_has_been_changed}
                />
            </SafeAreaView>
        );
    }

    handleButtonDisable = () => {
        const { passwordError, newPassword, isValiad } = this.state;
        if (newPassword === '' || passwordError !== null) return true;
        return !isValiad
    }

    resetPasswordStatus = (data) => {
        switch (data) {
            case 0:
                return this.setState({ currentPassowrdError: localize.Current_password_is_not_matched, isValiad: false })

            case 1:
                return this.setState({ passwordError: localize.The_length_of_password })

            case 200:
                return setTimeout(() => this.setState({ isVisible: true }), 300);

            default:
                return this.setState({ passwordError: localize.Failed_to_change_password })
        }

    }

}

const mapStateToProps = ({ setting }) => {
    return {
        height: setting.height,
    };
}
const mapDispatch = (dispatch) => {
    return {
        changeUserProfile: request => dispatch(changeUserProfile(request)),
        passwordValidate: request => passwordValidate(request),
        logoutUser: () => dispatch(logoutUser()),
        isLoading: (status) => dispatch({ type: status ? action.LOADING_DIALOG_TRUE : action.LOADING_DIALOG_FALSE }),
    }
}
export default connect(mapStateToProps, mapDispatch)(ResetUserPassword);